import React from "react";
import {
  Box,
  Typography,
  ToggleButton,
  IconButton,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/DeleteRounded";

const ActionMenu = ({
  toggleDrawer,
  editItem,
  handleSave,
  headerItemData,
  handleApi,
  isMobile,
}) => {
  let headerType = isMobile ? "mobileTopbar" : "customTopbar";

  const [image, setImage] = React.useState(
    headerItemData.customHeader[headerType].links[editItem.index].action.image
  );

  const isClickable =
    headerItemData.customHeader[headerType].links[editItem.index].action
      .isClickAble;
  const isPopupEnabled =
    headerItemData.customHeader[headerType].links[editItem.index].action
      .popupEnable;

  const handleActionForm = (key, value = "") => {
    if (key instanceof Object) {
      let name = key.target.name;
      value = key.target.value;
      handleSave("action", name, value);
      return;
    }
    handleSave("action", key, value);
  };

  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        const base64String = await convertToBase64(file);
        setImage(base64String);
        handleSave("action", "image", base64String);
      } catch (error) {
        console.error("Error converting file to Base64:", error);
      }
    }
  };

  const handleImageDelete = () => {
    setImage(null);
    headerItemData.customHeader[headerType].links[editItem.index].action.image =
      "";
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        borderRadius: "8px",
        backgroundColor: "#fff",
      }}
    >
      <Box
        sx={{
          backgroundColor: "#333",
          color: "#fff",
          padding: "5px",
          marginBottom: "14px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: "bold", fontSize: "16px" }}>
          {`Header Item ${editItem.index + 1} - Action`}
        </Typography>
        <Button
          variant="text"
          sx={{ fontWeight: "bold", color: "#fff" }}
          onClick={() => {
            toggleDrawer(true, editItem.index, "menu");
          }}
        >
          Back
        </Button>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "100%",
          width: "100%",
        }}
      >
        <Box
          sx={{
            padding: "0 10px",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            rowGap: "15px",
            width: "100%",
          }}
        >
          <Box
            sx={{
              marginBottom: "12px",
              display: "flex",
              justifyContent: "space-between",
              columnGap: "5px",
            }}
          >
            <ToggleButton
              value={true}
              sx={{
                fontSize: "11px",
                borderRadius: "50px",
                width: "50%",
                backgroundColor: isClickable ? "#7f7d7d" : "",
                color: isClickable ? "#fff" : "",
                "&:hover": {
                  color: "#757575",
                },
              }}
              onClick={() => {
                handleActionForm("isClickAble", true);
              }}
            >
              Clickable
            </ToggleButton>
            <ToggleButton
              value={false}
              sx={{
                fontSize: "11px",
                borderRadius: "50px",
                width: "50%",
                backgroundColor: !isClickable ? "#7f7d7d" : "",
                color: !isClickable ? "#fff" : "",
                "&:hover": {
                  color: "#757575",
                },
              }}
              onClick={() => {
                handleActionForm("isClickAble", false);
              }}
            >
              Not Clickable
            </ToggleButton>
          </Box>

          <input
            type="text"
            placeholder="Enter URL"
            value={
              headerItemData.customHeader[headerType].links[editItem.index]
                .action.url
            }
            onChange={handleActionForm}
            name="url"
            disabled={!isClickable}
            style={{
              width: "100%",
              outline: "none",
              border: "1px solid #999",
              padding: "10px 5px",
              textAlign: "center",
              borderRadius: "5px",
              backgroundColor: !isClickable ? "#e0e0e0" : "rgb(239 239 239)",
              cursor: !isClickable ? "not-allowed" : "text",
              opacity: !isClickable ? 0.7 : 1,
            }}
          />

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "10px 0",
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{ marginBottom: "8px", fontSize: "15px" }}
            >
              Popup Settings
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              columnGap: "5px",
            }}
          >
            <ToggleButton
              value={true}
              sx={{
                fontSize: "11px",
                borderRadius: "50px",
                width: "50%",
                backgroundColor: isPopupEnabled ? "#7f7d7d" : "",
                color: isPopupEnabled ? "#fff" : "",
                "&:hover": {
                  color: "#757575",
                },
              }}
              onClick={() => {
                handleActionForm("popupEnable", true);
              }}
            >
              Popup Enabled
            </ToggleButton>
            <ToggleButton
              value={false}
              sx={{
                fontSize: "11px",
                borderRadius: "50px",
                width: "50%",
                backgroundColor: !isPopupEnabled ? "#7f7d7d" : "",
                color: !isPopupEnabled ? "#fff" : "",
                "&:hover": {
                  color: "#757575",
                },
              }}
              onClick={() => {
                handleActionForm("popupEnable", false);
              }}
            >
              Popup Disabled
            </ToggleButton>
          </Box>

          {image ? (
            <Box sx={{ opacity: !isPopupEnabled ? 0.7 : 1 }}>
              <img
                src={image}
                alt="uploaded"
                style={{
                  width: "75px",
                  height: "75px",
                  objectFit: "cover",
                  display: "block",
                  marginBottom: "8px",
                }}
              />
              <IconButton
                size="small"
                onClick={handleImageDelete}
                sx={{
                  color: "red",
                }}
                disabled={!isPopupEnabled}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          ) : (
            <Button
              variant="outlined"
              component="label"
              sx={{
                width: "60%",
                opacity: !isPopupEnabled ? 0.7 : 1,
              }}
              disabled={!isPopupEnabled}
            >
              Select Popup Image
              <input
                type="file"
                accept="image/*"
                hidden
                onChange={handleImageUpload}
                disabled={!isPopupEnabled}
              />
            </Button>
          )}

          <input
            type="text"
            placeholder="Enter Popup Button Text"
            name="popupText"
            value={
              headerItemData.customHeader[headerType].links[editItem.index]
                .action.popupText
            }
            onChange={handleActionForm}
            disabled={!isPopupEnabled}
            style={{
              width: "100%",
              outline: "none",
              border: "1px solid #999",
              padding: "10px 5px",
              textAlign: "center",
              borderRadius: "5px",
              backgroundColor: !isPopupEnabled ? "#e0e0e0" : "rgb(239 239 239)",
              marginBottom: "12px",
              fontWeight:
                headerItemData.customHeader[headerType].links[editItem.index]
                  .action.buttonText === "bold"
                  ? "bold"
                  : "normal",
              cursor: !isPopupEnabled ? "not-allowed" : "text",
              opacity: !isPopupEnabled ? 0.7 : 1,
            }}
          />

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              columnGap: "5px",
              margin: "10px 0",
              opacity: !isPopupEnabled ? 0.7 : 1,
            }}
          >
            <ToggleButton
              value="bold"
              disabled={!isPopupEnabled}
              sx={{
                fontSize: "11px",
                borderRadius: "50px",
                width: "50%",
                backgroundColor:
                  headerItemData.customHeader[headerType].links[editItem.index]
                    .action.buttonText === "bold"
                    ? "#7f7d7d"
                    : "",
                color:
                  headerItemData.customHeader[headerType].links[editItem.index]
                    .action.buttonText === "bold"
                    ? "#fff"
                    : "",
                "&:hover": {
                  color: "#757575",
                },
                cursor: !isPopupEnabled ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                handleActionForm("buttonText", "bold");
              }}
            >
              Button Text: Bold
            </ToggleButton>
            <ToggleButton
              value="regular"
              disabled={!isPopupEnabled}
              sx={{
                fontSize: "11px",
                borderRadius: "50px",
                width: "50%",
                backgroundColor:
                  headerItemData.customHeader[headerType].links[editItem.index]
                    .action.buttonText === "regular"
                    ? "#7f7d7d"
                    : "",
                color:
                  headerItemData.customHeader[headerType].links[editItem.index]
                    .action.buttonText === "regular"
                    ? "#fff"
                    : "",
                "&:hover": {
                  color: "#757575",
                },
                cursor: !isPopupEnabled ? "not-allowed" : "pointer",
              }}
              onClick={() => {
                handleActionForm("buttonText", "regular");
              }}
            >
              Button Text: Regular
            </ToggleButton>
          </Box>
        </Box>

        <Button
          variant="contained"
          color="success"
          fullWidth
          sx={{
            fontSize: "12px",
            padding: "6px",
            width: "90%",
            borderRadius: "50px",
            margin: "30px 0 20px 0",
          }}
          onClick={handleApi}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default ActionMenu;
